import React from 'react';
import { TableColumn } from '@hero/ui-kit/tables/Table';
import Tag from '@hero/ui-kit/components/Tag';
import P from '@hero/ui-kit/typography/P';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import { useLocation, useNavigate } from 'react-router-dom';
import type { SegmentSummary } from '../../types';
const NameRender: React.FC<{
    segment: SegmentSummary;
}> = ({ segment }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const handleClick = () => {
        const from = `${location.pathname}${location.search}`;
        navigate(`/mark/segments/${segment.segment_id}`, { state: { from } });
    };
    return (
        <ClickableOpacity
            onClick={handleClick}
            alt="view-segment"
            styles={{
                cursor: 'pointer'
            }}
        >
            <P noDefaultMargin strong>
                <span
                    style={{
                        borderBottom: '1px solid var(--mark-primary)'
                    }}
                >
                    {segment.name}
                </span>
            </P>
        </ClickableOpacity>
    );
};
const kindTagType = (kind: SegmentSummary['kind']) => {
    switch (kind) {
        case 'QUERY':
            return 'primary' as const;
        case 'IMPORTED':
            return 'warn' as const;
    }
};
const getSegmentColumns = (): TableColumn<SegmentSummary>[] => [
    {
        colKey: 'name',
        name: 'Name',
        align: 'left',
        headAlign: 'left',
        render: (segment) => <NameRender segment={segment} />
    },
    {
        colKey: 'kind',
        name: 'Kind',
        align: 'left',
        headAlign: 'left',
        render: (segment) => (
            <Tag type={kindTagType(segment.kind)} size="small">
                {segment.kind}
            </Tag>
        )
    },
    {
        colKey: 'target_kind',
        name: 'Target',
        align: 'left',
        headAlign: 'left',
        render: (segment) => <P noDefaultMargin>{segment.target_kind}</P>
    },
    {
        colKey: 'filter_count',
        name: 'Filters',
        align: 'left',
        headAlign: 'left',
        render: (segment) => <P noDefaultMargin>{segment.filter_count}</P>
    }
];
export default getSegmentColumns;
